import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import API from '@/config/api';

import { pauseStateResponse, type UsePauseState, type UseSetPause } from './Pause.schema';

/** A pause flipped by someone else shows up within this window. */
const PAUSE_STATE_REFETCH_MS = 30_000;

export const pauseKeys = {
	state: ['pause', 'state'] as const,
};

export const usePauseState = (opts: UsePauseState['opts'] = {}) =>
	useQuery<UsePauseState['response']>({
		...opts,
		queryKey: pauseKeys.state,
		queryFn: () => API.get('/pause').then((res) => pauseStateResponse.parse(res.data)),
		refetchInterval: PAUSE_STATE_REFETCH_MS,
	});

export const useSetPause = (opts: UseSetPause['opts'] = {}) => {
	const qc = useQueryClient();

	return useMutation({
		...opts,
		mutationFn: (body) => API.post('/pause', body).then((res) => pauseStateResponse.parse(res.data)),
		onSuccess: (data, vars, ctx) => {
			// Show the change at once, then refetch the server's state as the source of truth.
			qc.setQueryData(pauseKeys.state, data);
			qc.invalidateQueries({ queryKey: pauseKeys.state });
			opts.onSuccess?.(data, vars, ctx);
		},
	});
};
